import { render, staticRenderFns } from "./GetMetallicMaterials.vue?vue&type=template&id=3fb2852c"
import script from "./GetMetallicMaterials.vue?vue&type=script&lang=js"
export * from "./GetMetallicMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports